import { apiClient } from '@/lib/api/client';
import { endpoints } from '@/lib/api/endpoints';

import {
  notificationListResponseSchema,
  notificationSettingsSchema,
  type NotificationListResponse,
} from './schemas';
import type { NotificationSettings } from './types';

/**
 * The whole feed is fetched at once (the seed is small) and the panel sorts /
 * derives unread client-side. The response keeps the `{ data, meta }` envelope,
 * where `meta.unread` drives the bell badge.
 */
export async function listNotifications(): Promise<NotificationListResponse> {
  const res = await apiClient.getList(endpoints.notifications.list);
  return notificationListResponseSchema.parse(res);
}

export async function markRead(id: string): Promise<void> {
  await apiClient.post(endpoints.notifications.read(id));
}

export async function markAllRead(): Promise<void> {
  await apiClient.post(endpoints.notifications.readAll);
}

/** The grower's notification delivery preferences (story 101880). */
export async function getNotificationSettings(): Promise<NotificationSettings> {
  const res = await apiClient.get(endpoints.notifications.settings);
  return notificationSettingsSchema.parse(res);
}

/**
 * Persist a partial change to the preferences. The server merges the patch and returns
 * the full, authoritative settings object (so the cache stays in sync after a toggle).
 */
export async function updateNotificationSettings(
  patch: Partial<NotificationSettings>,
): Promise<NotificationSettings> {
  const res = await apiClient.patch(endpoints.notifications.settings, patch);
  return notificationSettingsSchema.parse(res);
}
